import { render, staticRenderFns } from "./PersonalCardTypeInfo.vue?vue&type=template&id=2067e948&"
import script from "./PersonalCardTypeInfo.vue?vue&type=script&lang=js&"
export * from "./PersonalCardTypeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports